import { render, staticRenderFns } from "./SalesInvoiceExtract.vue?vue&type=template&id=003947f0&scoped=true"
import script from "./SalesInvoiceExtract.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceExtract.vue?vue&type=script&lang=js"
import style0 from "./SalesInvoiceExtract.vue?vue&type=style&index=0&id=003947f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003947f0",
  null
  
)

export default component.exports